<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_basketList_wrap">
      <h2>
        <span class="rew19_basketList_tit">장바구니</span>
      </h2>

      <div class="rew19_tabwrap">
        <ul class="rew19_linetab_pop nav nav-tabs nav-stacked">
          <li class="line_normal"><a :href="$aroShopBasketFullPath">일반</a></li>
          <li class="line_aro active"><a>신규 정기구매</a></li>
          <li class="line_normal" v-if="!isMyNuskinDomain">
            <a :href="$shopGiftBasketPageUrl">선물하기</a>
          </li>
        </ul>
      </div>

      <div class="rew19_basketList" v-if="!isShowBasketEmpty">
        <dl class="rew19_basketGroup" v-if="viewData.basketCount > 0">

          <!-- Basket Header -->
          <dt @click="onClickBasketHeader(0)"
              v-bind:class="{ rew19_on: basketChecks[0] }">
            <div class="rew19_wrapCheck_t1">
              <input
                ref="basket_check_1"
                @click.self="onClickBasketHeader(0)"
                type="checkbox" class="rew19_fakeCheck_t1" id="basket_check_1"/>
              <label for="basket_check_1">신규 정기구매 장바구니</label>
            </div>
            <button><span>열림</span></button>
          </dt>
          <!-- // Basket Header -->

          <dd
            v-show="basketChecks[0]"
            v-for="(basketItem) in viewData.basket"
            v-bind:key="basketItem.pd_id"
            class="rew19_product_container"
            style="disp"
          >
            <div class="rew19_product_tit">
              <div class="rew19_wrapCheck_t1">
                <!-- <input type="checkbox" class="rew19_fakeCheck_t1" name="fake-check_1_2" id="fake-check_1_2"> -->
                <label for="fake-check_1_2">{{ basketItem.pd_name_kr }}</label>
              </div>
              <button @click="onClickDeleteBasketItem(basketItem.pd_id, 'ARO', '')">
                <span>삭제</span>
              </button>
            </div>
            <!--//rew19_product_tit-->
            <div class="rew19_product_cont">
              <div class="rew19_relative rew19_relative_add rew19_change_position">
                <div class="rew19_goodsWrap">
                  <div class="rew19_goodsImg dev-productDetail">
                    <span class="rew18_goodsDim" v-if="basketItem.isSoldOut == 'Y'">
                      <em>일시품절</em>
                    </span>
                    <i class="rew19_goodsFlag"></i>

                    <span class="rew19_rateImg">
                      <img
                        :src="basketItem.pd_img_url1"
                        :alt="basketItem.pd_id"
                        onError="imageError(this)" data-error-cnt="0"
                      />
                    </span>
                  </div>
                </div>
                <div class="rew19_product_select">
                  <ul class="rew19_product_items">
                    <li>
                      <em class="rew19_gTit">정기구매가</em>
                      <span class="rew19_gDetail">
                        <strong id="18125002_check_prod_price">{{ $fmt.WON(basketItem.pd_amt1) }}</strong>원
                      </span>
                    </li>

                    <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">
                      <em class="rew19_gTit">SV</em>
                      <span
                        class="rew19_gDetail"
                        id="18125002_check_prod_pv"
                      >{{ $fmt.PV(basketItem.pv1) }}</span>
                    </li>
                    <li v-if="getMemberType() == 'DIST'">
                      <em class="rew19_gTit">CSV</em>
                      <span
                        class="rew19_gDetail"
                        id="18125002_check_prod_cv"
                      >{{ $fmt.PV(basketItem.cv1) }}</span>
                    </li>
<!--                    <li v-if="getMemberType() == 'DIST'">-->
<!--                      <em class="rew19_gTit">SB</em>-->
<!--                      <span-->
<!--                        class="rew19_gDetail"-->
<!--                        id="18125002_check_prod_sv"-->
<!--                      >{{ $fmt.PV(basketItem.sb1) }}</span>-->
<!--                    </li>-->
                  </ul>
                  <div class="rew19_numbering_wrap">
                    <em class="rew19_gTit">수량</em>
                    <div
                      class="rew19_numbering"
                      data-prodid="18125002"
                      data-groupid="0"
                      data-pdorderunit
                    >
                      <a
                        @click="onClickUpdateBasketItem(basketItem, -1, 'ARO')"
                        class="rew19_numbering_down dev-prod-qty-down"
                        title="감소"
                      ></a>
                      <!-- 에이지락미 상품이면 수량을 직접 입력할 수 없도록 함 -->
                      <input
                        type="tel"
                        class="onlynum dev-prod-qty"
                        id="18125002_qty"
                        v-model="basketItem.pd_count"
                        title="수량"
                        @keypress="isNumber($event)"
                        @keyup="calcTempCart(basketItem, 'ARO')"
                        :readonly="basketItem.agm_info"
                      />
                      <a @click="onClickUpdateBasketItem(basketItem, +1, 'ARO')"
                         class="rew19_numbering_up dev-prod-qty-up" title="증가"></a>
                    </div>

                    <div class="rew19_summary_wrap">
                      <em class="rew19_gTit">합계</em>
                      <span class="rew19_gDetail">
                        <strong>{{ $fmt.WON(basketItem.total_amt) }}</strong>원
                      </span>
                    </div>
                  </div>
                </div>
                <!--//rew19_product_select-->
              </div>
              <!--//rew19_relative-->
              <!--안내문구 포함 특정 상품-->
              <ul class="rew19_basketAdd_exp indent" v-show="basketItem.pd_id == '18125045'">
                <li>에이지락 미 스킨케어 시스템 구매는 이번 달에만 적용되어 결제 후 장바구니에서 즉시 삭제됩니다.</li>
                <li>결제 완료 내역은 나의 정기구매 History에서 확인</li>
                <li>재구매를 원하시는 경우에는 해당 월 결제일 전 다시 장바구니에 추가해 주시기 바랍니다.</li>
              </ul>
              <!--//안내문구 포함 특정 상품-->
              <ul class="rew19_codeList" id="ageloc_code_box" v-if="basketItem.agm_info">
                <li class="rew19_codeRow">
                  <span class="rew19_codeCol c1">순번</span>
                  <span class="rew19_codeCol c2">이름</span>
                  <span class="rew19_codeCol c3">코드</span>
                  <span class="rew19_codeCol c4">코드별명</span>
                  <span class="rew19_codeCol c5">코드조회</span>
                  <span class="rew19_codeCol c6">삭제</span>
                </li>
                <li
                  class="rew19_codeRow"
                  v-for="(Item, idx) in params.agm_info"
                  v-bind:key="idx"
                >
                  <span class="rew19_codeCol c1">{{ idx + 1 }}</span>
                  <span class="rew19_codeCol c2">
                    <em>이름</em>
                    <input
                      type="text"
                      title="이름"
                      maxlength="12"
                      class="rew19_inputTxt_t1"
                      v-model.trim="Item.agm_name"
                    />
                  </span>
                  <span class="rew19_codeCol c3">
                    <em>코드</em>
                    <input
                      type="text"
                      title="코드"
                      maxlength="6"
                      class="rew19_inputTxt_t1"
                      v-model.trim="Item.agm_code"
                      @input="toUpper(idx)"
                    />
                  </span>
                  <span class="rew19_codeCol c4">
                    <em>코드별명</em>
                    <input
                      type="text"
                      title="코드별명"
                      name="agelocmeAssessmentLabelArr"
                      maxlength="26"
                      class="rew19_inputTxt_t1"
                      v-model.trim="Item.agm_detail"
                    />
                  </span>
                  <span class="rew19_codeCol c5">
                    <button
                      @click="openSkinCareCodeListDialog(Item)"
                      type="button"
                      class="rew19_basketBtn_search"
                    >조회</button>
                  </span>
                  <span class="rew19_codeCol c6">
                    <button
                      v-show="params.agm_info.length > 1"
                      type="button"
                      class="rew19_basketBtn_del"
                      @click="onClickUpdateBasketItem(basketItem, -1, 'ARO', idx)"
                    >삭제</button>
                  </span>
                </li>
              </ul>
            </div>
            <!--//rew19_product_cont-->
          </dd>
          <dd v-show="basketChecks[0]" class="rew19_product_container">
            <div class="rew19_copy_wrap">
              <ul class="rew19_basketResult_mb">
                <li>
                  <em class="rew19_basketResult_tit">상품 합계</em>
                  <span class="rew19_basketResult_su">{{ $fmt.WON(viewData.payment_amt + viewData.saving_amt) }}원</span>
                </li>
                <li class="line">
                  <em class="rew19_basketResult_tit">정기구매할인</em>
                  <span class="rew19_basketResult_su">-{{ $fmt.WON(viewData.saving_amt) }}원</span>
                </li>
                <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">
                  <em class="rew19_basketResult_tit">합계 SV</em>
                  <span class="rew19_basketResult_su">{{ $fmt.PV(viewData.total_pv) }}</span>
                </li>
                <li v-if="getMemberType() == 'DIST'">
                  <em class="rew19_basketResult_tit">합계 CSV</em>
                  <span class="rew19_basketResult_su">{{ $fmt.PV(viewData.total_cv) }}</span>
                </li>
<!--                <li v-if="isShowTotalSb">-->
<!--                  <em class="rew19_basketResult_tit">합계 SB</em>-->
<!--                  <span class="rew19_basketResult_su">{{ $fmt.PV(viewData.total_sb) }}</span>-->
<!--                </li>-->
                <li>
                  <em class="rew19_basketResult_tit">결제예정금액</em>
                  <span class="rew19_basketResult_su">
                    <strong>{{ $fmt.WON(viewData.payment_amt) }}</strong>원
                  </span>
                </li>
              </ul>
            </div>

            <!--정기구매 장바구니 안내문구-->
            <ul v-show="basketChecks[0]" class="rew19_basketAdd_exp">
              <li>
                일반 회원 주문 시 총 {{ $fmt.WON(viewData.payment_amt + viewData.saving_amt) }}원의 상품합계를 정기구매 하시면
                <strong
                  class="rew19_text_point"
                >매월 {{ $fmt.WON(viewData.saving_amt) }}원</strong>
                을 할인 받아 {{ $fmt.WON(viewData.payment_amt) }}원에 구매하시게 됩니다.
              </li>
              <li>3개월 이전에 철회시에는 할인 받으신 금액을 결제하셔야 철회가 이루어집니다.</li>
            </ul>
            <!--정기구매 장바구니 안내문구-->
          </dd>
        </dl>

        <!-- 15% 약정 list -->
        <dl class="rew19_basketGroup" v-if="viewData.basketUspanListCount > 0">

          <!-- Basket Header -->
          <dt @click="onClickBasketHeader(1)"
              v-bind:class="{ rew19_on: basketChecks[1] }">
            <div class="rew19_wrapCheck_t1">
              <input
                ref="basket_check_2"
                @click.self="onClickBasketHeader(1)"
                type="checkbox" class="rew19_fakeCheck_t1" id="basket_check_2"/>
              <label for="basket_check_2">정기구매 스페셜 멤버십 장바구니</label>
            </div>
            <button><span>열림</span></button>
          </dt>
          <!-- // Basket Header -->

          <dd
            v-show="basketChecks[1]"
            v-for="(basketUspanItem) in viewData.basketUspanList"
            v-bind:key="basketUspanItem.pd_id"
            class="rew19_product_container"
          >
            <div class="rew19_product_tit">
              <div class="rew19_wrapCheck_t1">
                <!-- <input type="checkbox" class="rew19_fakeCheck_t1" name="fake-check_1_2" id="fake-check_2_1"> -->
                <label for="fake-check_2_1">{{ basketUspanItem.pd_name_kr }}</label>
              </div>
              <button @click="onClickDeleteBasketItem(basketUspanItem.pd_id, '15ARO', 'Y')">
                <span>삭제</span>
              </button>
            </div>
            <!--//rew19_product_tit-->
            <div class="rew19_product_cont">
              <div class="rew19_relative rew19_relative_add rew19_change_position">
                <div class="rew19_goodsWrap">
                  <div class="rew19_goodsImg dev-productDetail" data-prodid="18111721">
                    <span class="rew18_goodsDim" v-if="basketUspanItem.isSoldOut == 'Y'">
                      <em>일시품절</em>
                    </span>
                    <i class="rew19_goodsFlag"></i>

                    <span class="rew19_rateImg">
                      <img
                        :src="basketUspanItem.pd_img_url1"
                        :alt="basketUspanItem.pd_id"
                        onError="imageError(this)" data-error-cnt="0"
                      />
                    </span>
                  </div>
                </div>
                <div class="rew19_product_select">
                  <ul class="rew19_product_items">
                    <li>
                      <em class="rew19_gTit">정기구매가</em>
                      <span class="rew19_gDetail">
                        <strong
                          id="18125002_check_prod_price"
                          data-price="4200.0"
                        >{{ $fmt.WON(basketUspanItem.pd_amt3) }}</strong>원
                      </span>
                    </li>

                    <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">
                      <em class="rew19_gTit">SV</em>
                      <span
                        class="rew19_gDetail"
                        id="18125002_check_prod_pv"
                      >{{ $fmt.PV(basketUspanItem.pv3) }}</span>
                    </li>
                    <li v-if="getMemberType() == 'DIST'">
                      <em class="rew19_gTit">CSV</em>
                      <span
                        class="rew19_gDetail"
                        id="18125002_check_prod_cv"
                      >{{ $fmt.PV(basketUspanItem.cv3) }}</span>
                    </li>
<!--                    <li v-if="getMemberType() == 'DIST'">-->
<!--                      <em class="rew19_gTit">SB</em>-->
<!--                      <span-->
<!--                        class="rew19_gDetail"-->
<!--                        id="18125002_check_prod_sv"-->
<!--                      >{{ $fmt.PV(basketUspanItem.sb3) }}</span>-->
<!--                    </li>-->
                  </ul>
                  <div class="rew19_numbering_wrap">
                    <em class="rew19_gTit">수량</em>
                    <div
                      v-if="basketUspanItem.pd_id != '18155987'"
                      class="rew19_numbering"
                      data-prodid="18125002"
                      data-groupid="0"
                      data-pdorderunit
                    >
                      <a
                        @click="onClickUpdateBasketItem(basketUspanItem, -1, '15ARO')"
                        class="rew19_numbering_down dev-prod-qty-down"
                        title="감소"
                      ></a>
                      <input
                        type="tel"
                        class="onlynum dev-prod-qty"
                        id="18125002_qty"
                        v-model="basketUspanItem.pd_count"
                        title="수량"
                        @keypress="isNumber($event)"
                        @keyup="calcTempCart(basketUspanItem, '15ARO')"
                      />
                      <a @click="onClickUpdateBasketItem(basketUspanItem, +1, '15ARO')"
                         class="rew19_numbering_up dev-prod-qty-up" title="증가"></a>
                    </div>

                    <span v-if="basketUspanItem.pd_id == '18155987'" class="rew19_gDetail">{{basketUspanItem.pd_count}}개</span>

                    <div class="rew19_summary_wrap">
                      <em class="rew19_gTit">합계</em>
                      <span class="rew19_gDetail">
                        <strong>{{ $fmt.WON(basketUspanItem.pd_amt3) }}</strong>원
                      </span>
                    </div>
                  </div>
                </div>
                <!--//rew19_product_select-->
              </div>
              <!--//rew19_relative-->
            </div>
            <!--//rew19_product_cont-->
          </dd>
          <dd v-show="basketChecks[1]" class="rew19_product_container">
            <div class="rew19_copy_wrap">
              <ul class="rew19_basketResult_mb">
                <li>
                  <em class="rew19_basketResult_tit">상품 합계</em>
                  <span
                    class="rew19_basketResult_su"
                  >{{ $fmt.WON(viewData.uspan_payment_amt + viewData.uspan_saving_amt) }}원</span>
                </li>
                <li class="line">
                  <em class="rew19_basketResult_tit">정기구매할인</em>
                  <span class="rew19_basketResult_su">-{{ $fmt.WON(viewData.uspan_saving_amt) }}원</span>
                </li>
                <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">
                  <em class="rew19_basketResult_tit">합계 SV</em>
                  <span class="rew19_basketResult_su">{{ $fmt.PV(viewData.uspan_total_pv) }}</span>
                </li>
                <li v-if="getMemberType() == 'DIST'">
                  <em class="rew19_basketResult_tit">합계 CSV</em>
                  <span class="rew19_basketResult_su">{{ $fmt.PV(viewData.uspan_total_cv) }}</span>
                </li>
<!--                <li v-if="isShowTotalSb">-->
<!--                  <em class="rew19_basketResult_tit">합계 SB</em>-->
<!--                  <span class="rew19_basketResult_su">{{ $fmt.PV(viewData.uspan_total_sb) }}</span>-->
<!--                </li>-->
                <li>
                  <em class="rew19_basketResult_tit">결제예정금액</em>
                  <span class="rew19_basketResult_su">
                    <strong>{{ $fmt.WON(viewData.uspan_payment_amt) }}</strong>원
                  </span>
                </li>
              </ul>
            </div>

            <!--15% 정기구매 장바구니 안내문구-->
            <ul class="rew19_basketAdd_exp">
              <li>스마트 뷰티 멤버십 스타터 프로그램은 개별 약정으로만 신청 가능합니다. 다른 스페셜 멤버십 제품을 추가할 경우, 기존 장바구니 제품은 자동 삭제됩니다.</li>
              <li>정기구매 할인 금액은 첫 달 납입 금액에 맞추어 상품 합계에서 할인 반영된 점 참고 부탁 드립니다.</li>
              <li>각 제품에 해당하는 약정기간 이전 철회시에는, 할인 받으신 금액을 결제하셔야 철회가 이루어집니다. </li>
              <li>스마트 뷰티 멤버십 스타터 프로그램의 경우, 표기된 정기구매 장바구니 주문합계 금액은 디바이스 1개와 전용 제품 1개의 정상가 합계입니다. 정기구매 할인 금액은 첫달 납입 금액에 맞추어 상품 합계에서 할인 반영된 점 참고 부탁드립니다.</li>
              <!--              <li style="color:#FF0000;">에이지락 메타 10% 약정 정기구매 신청 시, 첫 달에 발송되는 본품과 사은품인 에이지락 메타의 유통기한은 모두 8월 중순 혹은 8월 말까지의 제품입니다. (유통기한 : 2023년 8월 17일, 2023년 8월 24일)</li>-->
            </ul>
            <!--15% 정기구매 장바구니 안내문구-->

            <div class="rew19_copy_wrap">
              <div class="rew19_payment_product">
                <p class="rew19_ptit">
                  <span class="rew19_gDetail">
                      정기구매 스페셜 멤버십 주문 시 유의사항
                  </span>
                </p>
                <ul class="rew19_pDetail rew18_clear rew19_payment_productDl">
                  <li>
                    <em>주문 가능 수량 : </em>
                    약정 기간(3개월)이 동일한 15% 약정 정기구매 제품과 스마트 뷰티 멤버십 플러스 프로그램 제품은 수량 제한이 없으며, 함께 결제하고 관리하실 수 있습니다.
                    단, 스마트 뷰티 멤버십 스타터 프로그램은 약정당 1개의 제품만 신청 가능합니다.
                  </li>
                  <button class="rew19_btnDetail down"><span>자세히 보기</span></button>
                  <!--<button class="rew19_btnDetail up"><span>닫기</span></button>-->
                </ul>
                <div class="rew19_payment_productDt rew19_paymentDon" style="display: none;">
                  <ul class="rew19_payment_productDl">
                    <li style="margin-bottom: 4px;">
                      <em>반품 : </em>
                      반품 시, 약정 철회로 인정됩니다. 또한 함께 구매한 제품 중 하나라도 반품하실 경우, 약정 철회로 진행됩니다.
                      <br/>
                    </li>
                    <li>
                      <em>약정 철회 : </em>
                      <ol>
                        <li>1) 약정 기간 이전 철회 시, 이전까지 받으신 할인 혜택을 모두 반환해야 합니다.
                        </li>
                        <li>2) 스마트 뷰티 멤버십 스타터 프로그램의 경우, 약정 기간(6개월) 이전 철회 시 스마트 뷰티 디바이스 잔존 금액(회원가에서 기 납입한 금액 제외) 및 전용 제품의 할인 금액을 모두 반환해야 합니다.</li>
                      </ol>
                    </li>
                  </ul>
                </div>
              </div><!--rew19_payment_product-->
            </div><!--rew19_copy_wrap-->
          </dd>
        </dl>

        <!-- ntc list -->
        <dl class="rew19_basketGroup" v-if="viewNtcData.basketNtcCount > 0">
          <!-- Basket Header -->
          <dt @click="onClickBasketHeader(2)"
              v-bind:class="{ rew19_on: basketChecks[2] }">
            <div class="rew19_wrapCheck_t1">
              <input
                ref="basket_check_3"
                @click.self="onClickBasketHeader(2)"
                type="checkbox" class="rew19_fakeCheck_t1" id="basket_check_3"/>
              <label for="basket_check_3">신규 NTC 장바구니</label>
            </div>
            <button><span>열림</span></button>
          </dt>
          <!-- // Basket Header -->

          <dd
            v-show="basketChecks[2]"
            v-for="(basketNtcItem) in viewNtcData.basketNtc"
            v-bind:key="basketNtcItem.pd_id"
            class="rew19_product_container"
          >
            <div class="rew19_product_tit">
              <div class="rew19_wrapCheck_t1">
                <!-- <input type="checkbox" class="rew19_fakeCheck_t1" name="fake-check_1_2" id="fake-check_1_2"> -->
                <label for="fake-check_1_2">{{ basketNtcItem.pd_name_kr }}</label>
              </div>
              <button @click="onClickDeleteBasketItem(basketNtcItem.pd_id, 'NTC', '')">
                <span>삭제</span>
              </button>
            </div>
            <!--//rew19_product_tit-->
            <div class="rew19_product_cont">
              <div class="rew19_relative rew19_relative_add rew19_change_position">
                <div class="rew19_goodsWrap">
                  <div class="rew19_goodsImg dev-productDetail">
                    <i class="rew19_goodsFlag"></i>

                    <span class="rew19_rateImg">
                      <img
                        :src="basketNtcItem.pd_img_url1"
                        :alt="basketNtcItem.pd_id"
                        onError="imageError(this)" data-error-cnt="0"
                      />
                    </span>
                  </div>
                </div>
                <div class="rew19_product_select">
                  <ul class="rew19_product_items">
                    <li>
                      <em class="rew19_gTit">정기구매가</em>
                      <span class="rew19_gDetail">
                        <strong id="18125002_check_prod_price">{{ $fmt.WON(basketNtcItem.pd_amt1) }}</strong>원
                      </span>
                    </li>

                    <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">
                      <em class="rew19_gTit">SV</em>
                      <span
                        class="rew19_gDetail"
                        id="18125002_check_prod_pv"
                      >{{ $fmt.PV(basketNtcItem.pv1) }}</span>
                    </li>
                    <li v-if="getMemberType() == 'DIST'">
                      <em class="rew19_gTit">CSV</em>
                      <span
                        class="rew19_gDetail"
                        id="18125002_check_prod_cv"
                      >{{ $fmt.PV(basketNtcItem.cv1) }}</span>
                    </li>
<!--                    <li v-if="getMemberType() == 'DIST'">-->
<!--                      <em class="rew19_gTit">SB</em>-->
<!--                      <span-->
<!--                        class="rew19_gDetail"-->
<!--                        id="18125002_check_prod_sv"-->
<!--                      >{{ $fmt.PV(basketNtcItem.sb1) }}</span>-->
<!--                    </li>-->
                  </ul>
                  <div class="rew19_numbering_wrap">
                    <em class="rew19_gTit">수량</em>
                    <div
                      class="rew19_numbering"
                      data-prodid="18125002"
                      data-groupid="0"
                      data-pdorderunit
                    >
                      <a
                        @click="onClickUpdateBasketItem(basketNtcItem, -1, 'NTC')"
                        class="rew19_numbering_down dev-prod-qty-down"
                        title="감소"
                      ></a>
                      <input
                        type="tel"
                        class="onlynum dev-prod-qty"
                        id="18125002_qty"
                        v-model="basketNtcItem.pd_count"
                        title="수량"
                        @keypress="isNumber($event)"
                        @keyup="calcTempCart(basketNtcItem, 'NTC')"
                      />
                      <a @click="onClickUpdateBasketItem(basketNtcItem, +1, 'NTC')"
                         class="rew19_numbering_up dev-prod-qty-up" title="증가"></a>
                    </div>

                    <div class="rew19_summary_wrap">
                      <em class="rew19_gTit">합계</em>
                      <span class="rew19_gDetail">
                        <strong>{{ $fmt.WON(basketNtcItem.total_amt) }}</strong>원
                      </span>
                    </div>
                  </div>
                </div>
                <!--//rew19_product_select-->
              </div>
              <!--//rew19_relative-->
            </div>
            <!--//rew19_product_cont-->
          </dd>
          <dd v-show="basketChecks[2]" class="rew19_product_container">
            <div class="rew19_copy_wrap">
              <ul class="rew19_basketResult_mb">
                <li>
                  <em class="rew19_basketResult_tit">상품 합계</em>
                  <span class="rew19_basketResult_su">{{ $fmt.WON(viewNtcData.payment_amt) }}원</span>
                </li>
                <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">
                  <em class="rew19_basketResult_tit">합계 SV</em>
                  <span class="rew19_basketResult_su">{{ $fmt.PV(viewNtcData.total_pv) }}</span>
                </li>
                <li v-if="getMemberType() == 'DIST'">
                  <em class="rew19_basketResult_tit">합계 CSV</em>
                  <span class="rew19_basketResult_su">{{ $fmt.PV(viewNtcData.total_cv) }}</span>
                </li>
<!--                <li v-if="isShowTotalSb">-->
<!--                  <em class="rew19_basketResult_tit">합계 SB</em>-->
<!--                  <span class="rew19_basketResult_su">{{ $fmt.PV(viewNtcData.total_sb) }}</span>-->
<!--                </li>-->
                <li>
                  <em class="rew19_basketResult_tit">결제예정금액</em>
                  <span class="rew19_basketResult_su">
                    <strong>{{ $fmt.WON(viewNtcData.payment_amt) }}</strong>원
                  </span>
                </li>
              </ul>
            </div>

          </dd>
        </dl>
      </div>
      <!--//rew19_basketList-->
      <div v-show="isShowBasketEmpty" class="rew19_noData_wrap">
        <span class="rew19_noData">장바구니가 비었습니다.</span>
      </div>
    </div>
    <!--//rew19_basketList_wrap-->

    <div v-show="!isShowBasketEmpty" class="rew19_basketList_fixed item2">
      <div class="rew19_basketItems_wrap">
        <h3>
          <!--일반 정기구매인 경우-->
          <span>정기구매</span>
          <!--15% 약정인 경우
          <span>15% 약정 정기구매</span>-->
          <em>장바구니 주문합계</em>
        </h3>
        <p class="rew19_basketPrice">
          <em>상품 합계</em>
          <span>
            <strong>{{ $fmt.WON(totalData.payment_amt + totalData.saving_amt) }}</strong>원
          </span>
        </p>
        <p class="rew19_basketPrice line">
          <em>정기구매할인</em>
          <span>
            <strong>-{{ $fmt.WON(totalData.saving_amt) }}</strong>원
          </span>
        </p>
        <p v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'"
           class="rew19_basketPrice mb-sv-show">
          <em>
            <i>합계</i> SV
          </em>
          <span>{{ $fmt.PV(totalData.total_pv) }}</span>
        </p>
        <p v-if="getMemberType() == 'DIST'" class="rew19_basketPrice">
          <em>합계 CSV</em>
          <span>{{ $fmt.PV(totalData.total_cv) }}</span>
        </p>
<!--        <p v-if="isShowTotalSb" class="rew19_basketPrice">-->
<!--          <em>합계 SB</em>-->
<!--          <span>{{ $fmt.PV(totalData.total_sb) }}</span>-->
<!--        </p>-->
        <p class="rew19_basketPrice sum">
          <em>결제 예정 금액</em>
          <span>
            <strong>{{ $fmt.WON(totalData.payment_amt) }}</strong>원
          </span>
        </p>
      </div>
      <a @click="onClickPaymentApply()" class="rew19_basket">
        <span>신규 정기구매 신청</span>
      </a>
    </div>

    <!--스킨케어 코드 목록 조회 -->
    <skin-care-code-list-dialog
      :show="skinCareCodeListDialogShow"
      @close="setSkinCareCodeFromList"
      ref="skinCareCodeListDialog"
    ></skin-care-code-list-dialog>

    <!--스킨케어 재고부족 알림 -->
    <skin-care-stock-dialog
      :show="skinCareStockDialogShow"
      @close="setSkinCareStock"
      ref="skinCareStockDialog"
    ></skin-care-stock-dialog>

  </div>
  <!--rew19_aro_wrap-->
</template>
<script>
import AroBase from '@/components/base/AroBase';
import SkinCareCodeListDialog from '@/components/popup/SkinCareCodeListDialog';
import SkinCareStockDialog from '@/components/popup/SkinCareStockDialog';

import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";

const MAX_PD_COUNT = 999;
const ERR_TITLE = "안내";
const ERR_MSG_MIN_PD_COUNT = "최소 구매 수량보다 작습니다.";
const ERR_MSG_MAX_PD_COUNT = "최대 구매 수량을 초과 하였습니다.";

const AGM_DEF_OBJ = {
  id: "",
  agm_code: "",
  agm_name: "",
  agm_detail: ""
};

export default {
  name: "AroCart",
  extends: AroBase,
  components: {
    SkinCareCodeListDialog,
    SkinCareStockDialog
  },
  computed: {
    isMyNuskinDomain() { // 마이사이트일 경우 선물하기 탭 삭제
      return window.location.hostname.includes("mynuskin.co.kr");
    }
  },
  data: () => ({
    //View Data
    viewData:
      {
        basket: [],
        basketPrmList: [],
        basketGrpList: [],
        basketUspanList: [],

        // prmcode: "F002",
        // prm_total_pv: "0.0",
        // prm_total_cv: "0.0",
        // prm_total_sb: "0.0",
        // prm_payment_amt: 0,
        // prm_saving_amt: 0,
        // prm_message1: "회원님은 ARO 정기주문으로 월 0원을 할인 받으십니다.",
        // total_pv: "165.85999999999999",
        // total_cv: "188370.57",
        // total_sb: "14580.0",
        // payment_amt: 269000,
        // basket_orderyn: "Y",
        // saving_amt: 30000,
        // saving_percentage: "5",
        // message1: "회원님은 ARO 정기주문으로 월 30,000원을 할인 받으십니다.",
        // status: "0000",
        // message: "조회 성공",
        // aroCheck: "Y",
        // aroCheckMsg1:
        //   "기존 진행 중인 ARO가 있습니다. 그래도 신규 ARO를 추가로 신청하시겠습니까?",
        // aroCheckMsg2:
        //   "기존 진행 중인 ARO에 제품을 추가하고자 하실 경우 ‘나의 ARO’ 에서  제품을 추가하실 ARO 주문을 선택하신 후 ‘변경’을 진행해주세요.",
        // couponDiscountCheck: "N",
        // couponDiscountMsg:
        //   "본 ARO 주문에 한해서 신규 할인 쿠폰 프로모션이 적용됩니다. 최초 신청하신 본 ARO 주문을 철회 하실 경우, 할인 혜택을 받으실 수 없습니다.",
        // uspan_total_pv: "0.0",
        // uspan_total_cv: "0.0",
        // uspan_total_sb: "0.0",
        // uspan_payment_amt: 0,
        // uspan_saving_amt: 0,
        // uspan_message1: "회원님은 ARO 정기주문으로 월 0원을 할인 받으십니다.",
      },
    viewNtcData:
      {
        basketNtc: []
        // total_pv: "165.85999999999999",
        // total_cv: "188370.57",
        // total_sb: "14580.0",
        // payment_amt: 269000,
      },

    basketChecks: [true, false, false],

    isShowBasketEmpty: false,
    isShowAgelocMe: false,
    isShow15Info: false,

    totalData: {
      total_pv: 0,
      total_cv: 0,
      // total_sb: 0,
      payment_amt: 0,
      saving_amt: 0
    },

    params: {
      pd_add_list: [],
      pd_id: "",
      pd_count: "",
      division_code: "",
      agm_info: [],
      id: "",
      uspan_yn: "",
      idx: null
    },

    skinCareProductIdx: "",
    basketMode: "",

    skinCareDialog: {
      showSkinCareDialog: false
    },

    skinCareCodeListDialogShow: false,
    skinCareCodeListDialog: {},

    skinCareStockDialogShow: false,

    // isShowTotalSb: false,

    agelocTempMsg: "",
  }),
  created() {
  },

  mounted() {
    let _this = this;

    _this.loadList();

    // if (_this.getMemberType() == "DIST" && _this.getMemberTitle() >= 40) {
    //   _this.isShowTotalSb = true;
    // }
  },

  methods: {
    uiInit() {
      $(".rew19_btnDetail").off();
      $(".rew19_btnDetail").click(function () { // 결제 자세히보기
        if ($(this).parent().next().hasClass("rew19_paymentDon")) {
          $(this).parent().next().show();
          $(this).parent().addClass("rew19_on");
          $(this).parent().next().removeClass("rew19_paymentDon");
        } else {
          $(this).parent().next().hide();
          $(this).parent().removeClass("rew19_on");
          $(this).parent().next().addClass("rew19_paymentDon");
        }
      });
    },

    //장바구별 상단 해더 클릭시
    onClickBasketHeader: function (idx) {
      let _this = this;

      let beforeFlag = _this.basketChecks[idx];
      _this.basketChecks = _this.basketChecks.map((item, sIdx) => {
        if (idx == sIdx) {
          return !item;
        }

        return !beforeFlag ? false : item;
      });

      _this.basketChecks.forEach((item, sIdx) => {
        let refs = _this.$refs['basket_check_' + (sIdx + 1)];
        if (refs) {
          refs.checked = item;
        }
      });

      let passIdx = 0;
      if (_this.basketChecks[idx]) {
        passIdx = idx + 1;
      }

      _this.changeBasketTotalAmount(passIdx);
    },

    //카테고리 가져오기
    apiGetBasket: function () {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_cart`, {
        params: {}
      });
    },
    apiChangeCart: function (mode) {
      let _this = this;
      let cartData = {};

      if (mode == '15ARO') {
        cartData = {
          pd_id: _this.params.pd_id,
          pd_count: _this.params.pd_count,
          uspan_yn: 'Y'
        }
      } else {
        cartData = {
          pd_id: _this.params.pd_id,
          pd_count: _this.params.pd_count
        }
      }

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_cart`, {
        params: cartData
      });
    },
    apiDeleteCart: function () {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/delete_cart`, {
        params: {
          pd_id: _this.params.pd_id,
          uspan_yn: _this.params.uspan_yn
        }
      });
    },
    apiGetNtcBasket: function () {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/ntc/carts`, {
        params: {}
      });
    },
    apiChangeNtcCart: function () {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/ntc/put_carts`, {
        params: {
          pd_id: _this.params.pd_id,
          pd_count: _this.params.pd_count
        }
      });
    },
    apiDeleteNtcCart: function () {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/ntc/delete_carts`, {
        params: {
          pd_id: _this.params.pd_id,
          uspan_yn: _this.params.uspan_yn
        }
      });
    },
    apiCheckAtp: function () {
      let _this = this;

      let params = {};

      params = {
        SalesOrder_channel: "ADR",
        SalesOrder_pickup_location: "KR02",
        ATP_type: "SAP",
        ATP_item_count: _this.params.agm_info.length
      }

      let agmInfoList = _this.params.agm_info;

      for (var i = 0; i < agmInfoList.length; i++) {
        var iItem = agmInfoList[i];
        var iIndex = i + 1;

        var iProdIdKey = "ATP_" + iIndex + "_prod_id";
        var iRequestedQuantityKey = "ATP_" + iIndex + "_requestedQuantity";
        var iAgeLocMeAssessmentCode = "ATP_" + iIndex + "_agelocmeAssessmentCode";

        let agmInfo = {};
        agmInfo[iProdIdKey] = Const.ARO_SKINCARE_PRODUCT_ID;
        agmInfo[iRequestedQuantityKey] = "1";
        var agmCode = iItem.agm_code;
        agmInfo[iAgeLocMeAssessmentCode] = agmCode;

        params = {...params, ...agmInfo}
      }

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/atp`, {
        params: params,
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },
    apiPutCartAgelocme: function () {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_cart_agelocme`, {
        params: {
          pd_add_list: JSON.stringify(_this.params.pd_add_list)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },
    findProdByIds(prodId, mode) {
      let _this = this;

      let refList = [];
      let priceColName = "";
      if (mode == Const.ARO_BASKET_MODE) {
        //타입별
        refList = _this.viewData.basket;
        priceColName = "pd_amt1"
      } else if (mode == Const.ARO_15_BASKET_MODE) {
        refList = _this.viewData.basketUspanList;
        priceColName = "pd_amt3"
      } else {
        refList = _this.viewNtcData.basketNtc;
        priceColName = "pd_amt1";
      }

      let filterdList = refList.filter(item => {
        return prodId == item.pd_id;
      })

      let retListValue = filterdList.map(item => {
        return {
          name: item.pd_name_kr,
          id: item.pd_id,
          price: item[priceColName] ? item[priceColName] : '',
          brand: item.brandName ? item.brandName : '',
          category: item.categoryName ? item.categoryName : '',
          variant: 'ARO',
          quantity: item.pd_count
        };
      });

      return retListValue;
    },
    gaBasketList(mode) {
      let _this = this;

      let refList = [];
      let priceColName = "";
      if (mode == Const.ARO_BASKET_MODE) {
        //타입별
        refList = _this.viewData.basket;
        priceColName = "pd_amt1"
      } else if (mode == Const.ARO_15_BASKET_MODE) {
        refList = _this.viewData.basketUspanList;
        priceColName = "pd_amt3"
      } else {
        refList = _this.viewNtcData.basketNtc;
        priceColName = "pd_amt1";
      }

      let retListValue = refList.map(item => {
        return {
          name: item.pd_name_kr,
          id: item.pd_id,
          price: item[priceColName] ? item[priceColName] : '',
          brand: item.brandName ? item.brandName : '',
          category: item.categoryName ? item.categoryName : '',
          variant: 'ARO',
          quantity: item.pd_count
        };
      });

      return retListValue;

    },

    //장바구니 리스트
    loadList: function () {
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetBasket().then(basketRes => {

        if (basketRes.status === 200 && basketRes.data.status === "0000") {
          _this.viewData = {...basketRes.data};

          let list = _this.viewData.basket;
          list.forEach((item) => {
            if (item.agm_info) {
              let paramsAgmList = _this.params.agm_info.length;
              if (paramsAgmList <= item.pd_count) {
                for (var i = 0; i < item.pd_count - paramsAgmList; i++) {
                  _this.params.agm_info.push(JSON.parse(JSON.stringify(AGM_DEF_OBJ)));
                }
              } else if (paramsAgmList > item.pd_count) {
                _this.params.agm_info.splice(paramsAgmList - 1, paramsAgmList - item.pd_count);
              }
            }
          });
          _this.changeBasketView();
          return _this.apiGetNtcBasket();
        } else {
          _this.$dialogs.alert(basketRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        }
      }).then(ntcBasketRes => {
        if (ntcBasketRes.status === 200 && ntcBasketRes.data.status === Const.ARO_DATA_API_SUCCESS) {
          _this.viewNtcData = {...ntcBasketRes.data};

          _this.changeBasketView();
        } else {
          _this.$dialogs.alert(ntcBasketRes.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        }
      })
        .catch(() => {
          this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        })
        .finally(() => {
          //hide loading
          _this.uiInit();
          _this.$hideLoading();
        });
    },

    calcTempCart: function (item, mode) {
      let _this = this;

      item.pd_count = parseInt("" + item.pd_count, 10);
      if (!item.pd_count || item.pd_count == NaN) {
        item.pd_count = 1;
      }

      if (item.pd_count < 1) {
        item.pd_count = 1;
      }

      if (MAX_PD_COUNT < item.pd_count) {
        _this.$dialogs.alert(ERR_MSG_MAX_PD_COUNT, {title: ERR_TITLE})
          .then(res => {
          });
        item.pd_count = MAX_PD_COUNT;
      }

      _this.params.pd_count = item.pd_count;
      _this.params.pd_id = item.pd_id;

      //일반 장바구니와 NTC 구분
      if (mode === Const.ARO_BASKET_MODE || mode === Const.ARO_15_BASKET_MODE) {
        _this.changeCartProductCount(mode);
      } else {
        _this.changeCartNtcProductCount();
      }
    },

    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
        ;
      } else {
        return true;
      }
    },

    changeCartProductCount: function (mode) {
      let _this = this;
      //show loading
      _this.$showLoading();
      //change cart
      _this.apiChangeCart(mode).then(changeCartRes => {

        if (changeCartRes.status === 200 && changeCartRes.data.status === Const.ARO_DATA_API_SUCCESS) {
          return _this.apiGetBasket();
        } else {
          _this.$dialogs.alert(changeCartRes.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        }
      }).then(basketRes => {

        if (basketRes.status === 200 && basketRes.data.status === Const.ARO_DATA_API_SUCCESS) {
          _this.viewData = {...basketRes.data};

          //에이지락 프로덕트 세트 낱개 삭제
          if (_this.params.idx != null) {
            _this.params.agm_info.splice(_this.params.idx, 1);
            _this.params.idx = null;
          }

          let list = _this.viewData.basket;
          list.forEach((item) => {
            if (item.agm_info) {
              let paramsAgmList = _this.params.agm_info.length;
              if (paramsAgmList <= item.pd_count) {
                for (var i = 0; i < item.pd_count - paramsAgmList; i++) {
                  _this.params.agm_info.push(JSON.parse(JSON.stringify(AGM_DEF_OBJ)));
                }
              } else if (paramsAgmList > item.pd_count) {
                _this.params.agm_info.splice(paramsAgmList - 1, paramsAgmList - item.pd_count);
              }
            }
          });

          _this.changeBasketViewMode(mode);
          //장바구니 변경 handler
          _this.$changeBasketCount();

        } else {
          _this.$dialogs.alert(basketRes.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        }
      })
        .catch(() => {
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        })
        .finally(() => {
          //hide loading
          _this.$hideLoading();
        });
    },

    deleteCartProduct: function (mode) {
      let _this = this;
      //show loading
      _this.$showLoading();
      //change cart
      _this.apiDeleteCart().then(deleteCartRes => {
        if (deleteCartRes.status === 200 && deleteCartRes.data.status === Const.ARO_DATA_API_SUCCESS) {
          if (_this.params.pd_id == Const.ARO_SKINCARE_PRODUCT_ID) {
            _this.params.agm_info = [];
          }
          return _this.apiGetBasket();
        } else {
          _this.$dialogs.alert(deleteCartRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        }
      }).then(basketRes => {
        if (basketRes.status === 200 && basketRes.data.status === Const.ARO_DATA_API_SUCCESS) {
          //GA 전송-장바구니 제품
          try {
            var product = _this.findProdByIds(_this.params.pd_id, mode);
            _this.sendGaProductToCart(product);
          } catch (e) {
            //ignore
            console.error(e);
          }
          _this.viewData = {...basketRes.data};
          _this.changeBasketView();

          //장바구니 변경 handler
          _this.$changeBasketCount();
        } else {
          _this.$dialogs.alert(basketRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        }
      })
        .catch(() => {
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        })
        .finally(() => {
          //hide loading
          _this.$hideLoading();
        });
    },

    changeCartNtcProductCount: function () {
      let _this = this;
      //show loading
      _this.$showLoading();
      //change cart
      _this.apiChangeNtcCart().then(changeCartRes => {
        if (changeCartRes.status === 200 && changeCartRes.data.status === Const.ARO_DATA_API_SUCCESS) {
          return _this.apiGetNtcBasket();
        } else {
          _this.$dialogs.alert(changeCartRes.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        }
      }).then(basketRes => {
        if (basketRes.status === 200 && basketRes.data.status === Const.ARO_DATA_API_SUCCESS) {
          _this.viewNtcData = {...basketRes.data};
          _this.changeBasketTotalAmount(3);
          //장바구니 변경 handler
          _this.$changeBasketCount();
        } else {
          _this.$dialogs.alert(basketRes.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        }
      })
        .catch(() => {
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        })
        .finally(() => {
          //hide loading
          _this.$hideLoading();
        });
    },

    deleteCartNtcProduct: function () {
      let _this = this;
      //show loading
      _this.$showLoading();
      //change cart
      _this.apiDeleteNtcCart().then(deleteCartRes => {
        if (deleteCartRes.status === 200 && deleteCartRes.data.status === Const.ARO_DATA_API_SUCCESS) {
          return _this.apiGetNtcBasket();
        } else {
          _this.$dialogs.alert(deleteCartRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        }
      }).then(basketRes => {
        if (basketRes.status === 200 && basketRes.data.status === Const.ARO_DATA_API_SUCCESS) {
          //GA 전송-장바구니 제품
          try {
            var product = _this.findProdByIds(_this.params.pd_id, 'mode');
            _this.sendGaProductToCart(product);
          } catch (e) {
            //ignore
            console.error(e);
          }

          _this.viewNtcData = {...basketRes.data};
          if (basketRes.data.basketNtc.length > 0) {
            _this.changeBasketTotalAmount(3);
          } else {
            _this.changeBasketView();
          }
          //장바구니 변경 handler
          _this.$changeBasketCount();
        } else {
          _this.$dialogs.alert(basketRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        }
      })
        .catch(() => {
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        })
        .finally(() => {
          //hide loading
          _this.$hideLoading();
        });
    },

    checkAtp: function () {
      let _this = this;

      let AtpSuccess = '';

      //NetFunnel : '장바구니' 화면에서 '정기구매 신청' 버튼 클릭시: act_12
      // NFStart({projectKey: 'service_1', segmentKey: 'act_12'}, function (response) {
      //show loading
      _this.$showLoading();
      //change cart

      /*
        _this.getAgelocTempMsg().then(agelocMeRes => {
          if(agelocMeRes.status === 200 && agelocMeRes.data.status === "0000") {
            if(agelocMeRes.data.result) {
              _this.agelocTempMsg = agelocMeRes.data.customKitTempMsg;
            } else {
              return null;
            }
            return _this.apiCheckAtp();
          } else {
            _this.$dialogs.alert(agelocMeRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});
          }
        }).catch((err) => {
          console.log(err);
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});
        }).finally(() => {
          _this.$hideLoading();
        });

        _this.apiCheckAtp().then(checkAtpRes => {
          // NFStop();
          if (checkAtpRes.status === 200 && checkAtpRes.data.status === "000") {
              let list = checkAtpRes.data.lineItems;
              for(var i=0; i<list.length; i++){
                if(list[i].status === "610" || list[i].backOrdered){
                _this.$refs.skinCareStockDialog.initData(list, _this.params.agm_info, _this.agelocTempMsg);
                _this.skinCareStockDialogShow = true;

                return null;
                }
              }
              return _this.apiPutCartAgelocme();

          }else{
            _this.$dialogs.alert(checkAtpRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
            });
            return null;
          }
        }).then(basketRes => {
          if(basketRes){
            if (basketRes.status === 200 && basketRes.data.status === Const.ARO_DATA_API_SUCCESS) {
              _this.paymentApply();

            }else{
              _this.$dialogs.alert(basketRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});
            }
          }
        })
        .catch(() => {
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});
        })
        .finally(() => {
          //hide loading
          _this.$hideLoading();
        });
      */

      _this.getAgelocTempMsg().then(agelocMeRes => {
        if (agelocMeRes.status === 200 && agelocMeRes.data.status === "0000") {
          if (agelocMeRes.data.result) {
            _this.agelocTempMsg = agelocMeRes.data.customKitTempMsg;
          } else {
            _this.agelocTempMsg = "";
          }
          return _this.apiCheckAtp();
        } else {
          _this.$dialogs.alert(agelocMeRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });

          return null;
        }
      }).then(checkAtpRes => {
        // NFStop();
        if (checkAtpRes) {
          if (checkAtpRes.status === 200 && checkAtpRes.data.status === "000") {
            let list = checkAtpRes.data.lineItems;
            for (var i = 0; i < list.length; i++) {
              if (list[i].status === "610" || list[i].backOrdered) {
                _this.$refs.skinCareStockDialog.initData(list, _this.params.agm_info, _this.agelocTempMsg);
                _this.skinCareStockDialogShow = true;

                return null;
              }
            }
            return _this.apiPutCartAgelocme();

          } else {
            _this.$dialogs.alert(checkAtpRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
            });
            return null;
          }
        }

      }).then(basketRes => {
        if (basketRes) {
          if (basketRes.status === 200 && basketRes.data.status === Const.ARO_DATA_API_SUCCESS) {
            _this.paymentApply();

          } else {
            _this.$dialogs.alert(basketRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
            });
          }
        }
      }).catch(() => {
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
        });
      }).finally(() => {
        //hide loading
        _this.$hideLoading();
      });
      // });
    },

    //open dialog 스킨케어 코드 조회
    openSkinCareCodeListDialog(agmItem) {
      let _this = this;

      //pass data to dialog
      _this.skinCareCodeListDialog = {
        ..._this.skinCareCodeListDialog,
        memberId: _this.getMemberId(),
        targetAgm: agmItem,
      };

      _this.$refs.skinCareCodeListDialog.initData(_this.skinCareCodeListDialog);

      _this.skinCareCodeListDialogShow = true;
    },

    //스킨케어 선택시
    setSkinCareCodeFromList(isOk, data) {
      let _this = this;

      _this.skinCareCodeListDialogShow = false;

      if (!isOk) {
        //Do nothing
        return;
      }

      // _this.skinCareCodeListDialog.agm_code = data.assessmentCode;
      // _this.skinCareCodeListDialog.targetAgm.agm_name = data.personName;
      // _this.skinCareCodeListDialog.targetAgm.agm_detail = data.assessmentLabel;

      _this.params.agm_info = _this.params.agm_info.map((item) => {
        if (_this.skinCareCodeListDialog.targetAgm == item) {
          return {
            ...item,
            agm_code: data.assessmentCode,
            agm_name: data.personName,
            agm_detail: data.assessmentLabel,
          };
        } else {
          return item;
        }
      });
    },


    paymentApply: function () {
      let _this = this;

      //GA 전송-장바구니 제품
      try {
        var product = _this.gaBasketList(_this.basketMode);
        _this.sendGaGoAroApply(product, function () {
          if (_this.basketMode === Const.ARO_BASKET_MODE) {
            _this.$router.push(`${_this.$aroBasePath}/payment?mode=${_this.basketMode}&uspan_yn=N&uspancode=`);
          } else if (_this.basketMode === Const.ARO_15_BASKET_MODE) {
            _this.$router.push(`${_this.$aroBasePath}/payment?mode=${_this.basketMode}&uspan_yn=Y&uspancode=${_this.viewData.prmcode}`);
          } else if (_this.basketMode === Const.ARO_NTC_BASKET_MODE) {
            _this.$router.push(`${_this.$aroBasePath}/payment?mode=${_this.basketMode}&uspan_yn=N&uspancode=`);
          }
        });
      } catch (e) {
        //ignore
        console.error(e);
      }


    },
    onClickUpdateBasketItem: function (item, add, mode, idx) {
      let _this = this;
      _this.params.pd_id = item.pd_id;
      _this.params.pd_count = item.pd_count + add;

      if (_this.params.pd_count < 1) {
        _this.params.pd_count = 1;
      }

      if (MAX_PD_COUNT < _this.params.pd_count) {
        _this.$dialogs.alert(ERR_MSG_MAX_PD_COUNT, {title: ERR_TITLE})
          .then(res => {
          });
        _this.params.pd_count = MAX_PD_COUNT;
      }

      //aro 구매 수량 제한
//      if(_this.params.pd_id == '18155997') {
//        if (_this.params.pd_count > 1) {
//          _this.$dialogs.alert(ERR_MSG_MAX_PD_COUNT, {title: ERR_TITLE})
//            .then(res => {
//            });
//          _this.params.pd_count = 1;
//        }
//      }

      if (item.pd_id == Const.ARO_SKINCARE_PRODUCT_ID && undefined != idx) {
        _this.params.idx = idx;
      }

      //일반 장바구니와 NTC 구분
      if (mode === Const.ARO_BASKET_MODE || mode === Const.ARO_15_BASKET_MODE) {
        _this.changeCartProductCount(mode);
      } else {
        _this.changeCartNtcProductCount();
      }

    },
    onClickDeleteBasketItem: function (pd_id, mode, uspan_yn) {
      let _this = this;
      _this.params.pd_id = pd_id;
      _this.params.uspan_yn = uspan_yn;

      //일반 장바구니와 NTC 구분
      if (mode === Const.ARO_BASKET_MODE || mode == Const.ARO_15_BASKET_MODE) {
        _this.deleteCartProduct(mode);
      } else {
        _this.deleteCartNtcProduct();
      }
    },
    onClickBasketTitle: function (mode) {
      let _this = this;
      _this.changeBasketTotalAmount(mode);
    },
    changeBasketView: function () {
      let _this = this;
      let idx = 0;
      if (_this.viewData.basketCount < 1 && _this.viewData.basketUspanListCount < 1 && _this.viewNtcData.basketNtc.length < 1) {
        //장바구니 비었을 경우
        _this.isShowBasketEmpty = true;
        _this.basketChecks = [false, false, false];
      } else if (_this.viewData.basketCount < 1 && _this.viewData.basketUspanListCount > 0) {
        //일반 X, 15% 약정 정기구매 O
        _this.isShowBasketEmpty = false;
        _this.basketChecks = [false, true, false];
        idx = 2;
      } else if (_this.viewData.basketCount < 1 && _this.viewData.basketUspanListCount < 1 && _this.viewNtcData.basketNtcCount > 0) {
        //일반 X, 15% 약정 정기구매 X, NTC 정기구매 O
        _this.isShowBasketEmpty = false;
        _this.basketChecks = [false, false, true];
        idx = 3;
      } else {
        // 일반 O
        _this.isShowBasketEmpty = false;
        _this.basketChecks = [true, false, false];
        idx = 1;
      }
      _this.changeBasketTotalAmount(idx);
    },
    changeBasketViewMode: function (mode) {
      let _this = this;
      let idx = 0;
      if (_this.viewData.basketCount < 1 && _this.viewData.basketUspanListCount < 1 && _this.viewNtcData.basketNtc.length < 1) {
        //장바구니 비었을 경우
        _this.isShowBasketEmpty = true;
        _this.basketChecks = [false, false, false];
      } else if (mode == '15ARO' && _this.viewData.basketUspanListCount > 0) {
        //일반 X, 15% 약정 정기구매 O
        _this.isShowBasketEmpty = false;
        _this.basketChecks = [false, true, false];
        idx = 2;
      } else if (_this.viewData.basketCount < 1 && _this.viewData.basketUspanListCount < 1 && _this.viewNtcData.basketNtcCount > 0) {
        //일반 X, 15% 약정 정기구매 X, NTC 정기구매 O
        _this.isShowBasketEmpty = false;
        _this.basketChecks = [false, false, true];
        idx = 3;
      } else {
        // 일반 O
        _this.isShowBasketEmpty = false;
        _this.basketChecks = [true, false, false];
        idx = 1;
      }
      _this.changeBasketTotalAmount(idx);
    },
    changeBasketTotalAmount: function (idx) {
      let _this = this;
      if (idx === 1) {
        _this.totalData.payment_amt = _this.viewData.payment_amt;
        _this.totalData.saving_amt = _this.viewData.saving_amt;
        _this.totalData.total_pv = _this.viewData.total_pv;
        _this.totalData.total_cv = _this.viewData.total_cv;
        // _this.totalData.total_sb = _this.viewData.total_sb;
      } else if (idx === 2) {
        _this.totalData.payment_amt = _this.viewData.uspan_payment_amt;
        _this.totalData.saving_amt = _this.viewData.uspan_saving_amt;
        _this.totalData.total_pv = _this.viewData.uspan_total_pv;
        _this.totalData.total_cv = _this.viewData.uspan_total_cv;
        // _this.totalData.total_sb = _this.viewData.uspan_total_sb;
      } else if (idx === 3) {
        _this.totalData.payment_amt = _this.viewNtcData.payment_amt;
        _this.totalData.saving_amt = 0;
        _this.totalData.total_pv = _this.viewNtcData.total_pv;
        _this.totalData.total_cv = _this.viewNtcData.total_cv;
        // _this.totalData.total_sb = _this.viewNtcData.total_sb;
      } else {
        _this.totalData.payment_amt = 0;
        _this.totalData.saving_amt = 0;
        _this.totalData.total_pv = 0;
        _this.totalData.total_cv = 0;
        // _this.totalData.total_sb = 0;
      }
    },
    onClickPaymentApply: function () {
      let _this = this;
      let mode = '';
      for (let i = 0; i < _this.basketChecks.length; i++) {
        if (_this.basketChecks[i]) {
          if (i === 0) {
            mode = Const.ARO_BASKET_MODE;
          } else if (i === 1) {
            mode = Const.ARO_15_BASKET_MODE;
          } else if (i === 2) {
            mode = Const.ARO_NTC_BASKET_MODE;
          }
        }
      }
      _this.basketMode = mode;
      let pdItem = {};

      //금액 확인
      if (_this.basketMode === Const.ARO_BASKET_MODE) {
        if (_this.viewData.basket_orderyn != "Y") {
          _this.$dialogs.alert("정기구매는 6만원 이상 결제하셔야 합니다.")
            .then(res => {
            });
          return false;
        }
      }

      // 품절 확인
      if (_this.basketMode === Const.ARO_BASKET_MODE) {
        let basket = _this.viewData.basket;
        for (let i = 0; i < basket.length; i++) {
          if (basket[i].isSoldOut == 'Y') {
            _this.$dialogs.alert("품절된 상품은 구매할 수 없습니다.")
              .then(res => {
              });
            return false;
          }
        }
      }

      // 15% 품절 확인
      if (_this.basketMode === Const.ARO_15_BASKET_MODE) {
        let basketUspan = _this.viewData.basketUspanList;
        for (let j = 0; j < basketUspan.length; j++) {
          if (basketUspan[j].isSoldOut == 'Y') {
            _this.$dialogs.alert("품절된 상품은 구매할 수 없습니다.")
              .then(res => {
              });
            return false;
          }
        }
      }

      // 300만원 이상 구매 제한
      if (_this.totalData.payment_amt > 3000000) {
        _this.$dialogs.alert("300만원 이상 구매시 정기구매 신청이 제한됩니다.")
          .then(res => {
          });
        return false;
      }

      //aro 구매 수량 제한
      //    if(_this.basketMode === Const.ARO_BASKET_MODE){
      //      let basket = _this.viewData.basket;
      //      for(let i=0; i<basket.length; i++){
      //        if (basket[i].pd_id == '18155997'){
      //          if (basket[i].pd_count > 1) {
      //            _this.$dialogs.alert(basket[i].pd_name_kr + " 제품의 신청 가능 수량은 1개 입니다.")
      //              .then(res => {
      //              });
      //            return false;
      //          }
      //        }
      //      }
      //    }

      if (_this.basketMode === Const.ARO_BASKET_MODE && _this.params.agm_info.length > 0) {
        let basket = _this.viewData.basket;
        for (let i = 0; i < basket.length; i++) {
          if (basket[i].agm_info) {
            pdItem.division_code = basket[i].division_code;
          }
        }

        let ageInfoComfirm = false;
        _this.params.agm_info.some((item) => {
          if (item.agm_code == "" || item.agm_name == "" || item.agm_detail == "") {
            _this.$dialogs.alert("에이지락 미 커스텀 프로덕트 세트 주문 시에는 스킨 케어 정보 입력이 반드시 필요합니다. 코드를 입력해주세요.")
              .then(res => {
              });
            ageInfoComfirm = false;
            return true;
          }
          pdItem.pd_id = Const.ARO_SKINCARE_PRODUCT_ID;
          pdItem.pd_count = _this.params.agm_info.length;
          pdItem.agm_info = [..._this.params.agm_info];
          ageInfoComfirm = true;
        })

        if (ageInfoComfirm) {
          //스킨케어코드 atp check
          _this.params.pd_add_list.push(pdItem);
          _this.checkAtp();
        }
      } else {
        _this.paymentApply();
      }
    },
    setSkinCareStock(isOk, data) {
      let _this = this;

      if (!isOk) {
        _this.skinCareStockDialogShow = false;
        return false;
      }

      if (data.length > 0) {
        _this.params.pd_add_list[0].agm_info = [...data];
        _this.params.pd_add_list[0].pd_count = data.length;

        _this.$showLoading();
        //change cart
        _this.apiPutCartAgelocme().then(basketRes => {
          if (basketRes.status === 200 && basketRes.data.status === Const.ARO_DATA_API_SUCCESS) {
            return _this.apiGetBasket();
          } else {
            _this.$dialogs.alert(basketRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
            });
          }
          return null;
        }).then(basketRes => {
          if (basketRes) {
            if (basketRes.status === 200 && basketRes.data.status === Const.ARO_DATA_API_SUCCESS) {
              if (basketRes.data.basket_orderyn != "Y") {
                _this.$dialogs.alert("정기구매는 6만원 이상 결제하셔야 합니다.").then(res => {
                  _this.skinCareStockDialogShow = false;
                });
              } else {
                _this.paymentApply();
              }
            } else {
              _this.$dialogs.alert(basketRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
              });
            }
          }
        }).catch(() => {
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          });
        })
          .finally(() => {
            //hide loading
            _this.$hideLoading();
          });
      } else {
        _this.params.pd_id = Const.ARO_SKINCARE_PRODUCT_ID;

        _this.$showLoading();
        //change cart
        _this.apiDeleteCart()
          .then(basketRes => {
            if (basketRes.status === 200 && basketRes.data.status === Const.ARO_DATA_API_SUCCESS) {
              return _this.apiGetBasket();
            } else {
              _this.$dialogs.alert(basketRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
              });
            }
            return null;
          })
          .then(basketRes => {
            if (basketRes) {
              if (basketRes.status === 200 && basketRes.data.status === Const.ARO_DATA_API_SUCCESS) {
                if (basketRes.data.basket_orderyn != "Y") {
                  _this.viewData = {...basketRes.data};
                  _this.params.agm_info = [];
                  _this.$dialogs.alert("정기구매는 6만원 이상 결제하셔야 합니다.").then(res => {
                    _this.skinCareStockDialogShow = false;

                  });
                } else {
                  _this.paymentApply();
                }
              } else {
                _this.$dialogs.alert(basketRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
                });
              }
            }
          })
          .catch(() => {
            _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
            });
          })
          .finally(() => {
            //hide loading
            _this.$hideLoading();
          });
      }
    },
    //GA 전송-장바구니 삭제 클릭
    sendGaProductToCart(prod) {
      let _this = this;

      let gaData = {
        event: 'removeFromCart_ARO',
        ecommerce: {
          removeFromCart: {
            products: prod
          }
        }
      };

      _this.$sendAroGA(gaData);
    },
    //GA 전송-장바구니 결제하기 버튼 클릭
    sendGaGoAroApply(prods, callback) {
      let _this = this;

      let gaData = {
        event: 'checkout_ARO',
        ecommerce: {
          checkout: {
            actionField: {step: 1},
            products: prods
          }
        }

      };
      _this.$sendAroGA(gaData, callback);
    },
    toUpper(index) {
      let _this = this;

      _this.params.agm_info[index].agm_code = _this.params.agm_info[index].agm_code.toUpperCase();
    },
    // 에이지락미 커스텀 키트 재고부족 시 temp 문구
    getAgelocTempMsg: function () {
      let _this = this;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/getAgelocMeTempMsg`, {
        param: {}
      });
    }
  }
};
</script>
<style>
.rew19_basketList .rew19_product_container {
  display: block;
}

a.rew19_basket, a.rew19_numbering_up, a.rew19_numbering_down {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/product/basket.vue